export default {
  en: {
    webinar_heading: 'Nutrition series with Ryan Carter and guests!',
    webinar_subheading:
      'Welcome to a four-part nutrition series with Ryan Carter, powered by Lifesum - Free of charge.',
    webinar_cta: 'Register to watch',
    webinar_info_heading: 'Register to learn how to eat nutritiously',
    webinar_info_callout: 'Get healthier in 2021!',
    webinar_info_1:
      'This spring, we will release an exclusive four-part nutrition series together with the registered nutritionist and founder of Live Vitae, Ryan Carter.',
    webinar_info_2:
      'Each episode will be released monthly, and together, we will dive deeper into the topic of nutrition, providing you with tools, knowledge, and inspiration to help you lead a healthy and happy lifestyle.',
    webinar_register_now: 'Register today!',
    webinar_link_to_all: 'Click here and head to all episodes',
    webinar_register_to_see: 'Register now to see the webinars',
    webinar_register: 'Register',
    webinar_login: 'Log in',
    webinar_ryan:
      'Certified Health Coach, Personal trainer, breathwork coach, and registered nutritional therapist. He is the founder of Live Vitae, an optimal health coaching platform that works by educating, supporting and mentoring clients from illness to wellness or sub-par to optimal.',
    webinar_registrated_info:
      'Thank you for signing up! You will receive an email with a join link in your inbox shortly',
    webinar_junk_mail: 'PS Make sure to check your junk mail.',
    webinar_already_registred: 'Already registered <span>Click here</span>',
    webinar_you_are_registred: 'Your mail is registered!',
    webinar_enter_mail: 'Enter the email you used when register',
    webinar_incorrect_email: 'Incorrect email',
    webinar_nonexistant_email: 'The email is not registered',
    webinar_countdown_heading: 'Pre-register today!',
    webinar_days: 'D',
    webinar_hours: 'H',
    webinar_minutes: 'M',
    webinar_seconds: 'S',
    webinare_register_dont_miss: "Don't miss out, register now!",
    webinar_date_heading: 'Episodes and release dates',
    webinar_who_are_we: 'Who am I',
    webinar_released: 'Will be released',
    webinar_episode: 'Episode {number}',
  },
  sv: {
    webinar_heading: 'Webinarserie med Karoline och Jackie!',
    webinar_subheading:
      'Välkommen till fem kostnadsfria online föreläsningar om kost och hälsa',
    webinar_cta: 'Jag vill se',
    webinar_info_heading: 'Kul att du vill kolla på våra föreläsningar!',
    webinar_info_callout: 'Gör 2021 till ditt häsloår!',
    webinar_info_1:
      'Under våren kommer vi släppa en exklusiv webinarserie där du får\
        förutsättningar att ta dig an det nya året med rätt verktyg för\
        att leva en hälsosammare livsstil.',
    webinar_info_2:
      'Ett avsnitt som släpps månadsvis, där du kommer lära dig allt\
        ifrån vilka kostmyter som stämmer till hur misslyckanden är en\
        del av lärandet.',
    webinar_register_now: 'Registrera dig idag!',
    webinar_link_to_all: 'Gå till alla webinars',
    webinar_register_to_see: 'Registrera dig nu för att se webinaren',
    webinar_register: 'Registrera',
    webinar_login: 'Logga in',
    webinar_jackie:
      'Näringsfysiolog från Karolinska Institutet som specialiserat sig inom idrottsnutrition. \
      Tävlat i body fitness med SM-guld i bagaget och har även coachat andra. \
      Jobbar som föreläsare för blivande kostrådgivare och på Lifesum inom marknadsföring.',
    webinar_kp:
      'Legimiterad dietist. Arbetar dagligen med vikthantering och att grundligt förstå sina klienters behov och mål. Jobbar aktivt runt hur man ser på mat och hur det kan påverka hälsa och välmående i vardagen.',
    webinar_registrated_info:
      'Du är registerad, vi kommer maila dig när nästa webinar släpps!',
    webinar_junk_mail:
      'Kolla din skräppost om du inte får en bekräftelse på din registrering.',
    webinar_already_registred: 'Är du redan registerad <span>Klicka här</span>',
    webinar_you_are_registred: 'Din mail är registerad',
    webinar_enter_mail: 'Fyll i mailen du registerade dig med',
    webinar_incorrect_email: 'Ogiltig e-postadress',
    webinar_nonexistant_email: 'E-postadressen är inte registerad',
    webinar_countdown_heading: 'Förhandsregistrera dig redan idag!',
    webinar_days: 'Dagar',
    webinar_hours: 'Tim',
    webinar_minutes: 'Min',
    webinar_seconds: 'Sek',
    webinar_register_dont_miss: 'Registera dig nu för att inte missa!',
    webinar_date_heading: 'Datum för webinars',
    webinar_who_are_we: 'Vilka är vi',
    webinar_released: 'Släpps',
    webinar_episode: 'Avsnitt {number}',
  },
}
